import React from 'react'
import { AssessDashCircle, AssessSkillBar, } from '..'
import { Card, CardBody, Row, Col, } from 'reactstrap'
import assessmentColors from '../../../helpers/assessment/assessmentColors';
import { Link,Redirect } from 'react-router-dom'


export default function SubtestReportTopCard({ title, scores, subject, isStudent ,query,routeParams,scoresCompare,isCompare, test1, test2, isSwap}) {
  // AssessDashCircle props to pass

  let linkto = null
  if(routeParams && query){
    linkto = `/assessment/testing/${routeParams.userAssessmentId}/${routeParams.subTestSetId}?item=overview&g=${query.g}&a=${query.a}`
   }
  

  let labels = ['English', 'Math', 'Reading', 'Science', '']
  let data = [1, 1, 1, 1, 0]
  let backgroundColor = ['#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d']
  let hoverBackgroundColor = backgroundColor
  let color = '#ffc107'
  let themeColor = 'warning'

  if (scores && subject) {
    color = assessmentColors(subject, true)
    themeColor = assessmentColors(subject, false)
    labels = [subject, '']
    data = [scores.scale, 36 - scores.scale]
    backgroundColor = [color, '#4d4d4d']
    hoverBackgroundColor = backgroundColor
  }
  let score = 0
  if (scores) {
    score = scores.scale
    if (isStudent) {
      score = Math.round(score)
    } else {
      score = Math.round(score * 10) / 10
    }
  }

//-=-------------
if (scoresCompare && subject) {
  color = assessmentColors(subject, true)
  themeColor = assessmentColors(subject, false)
  labels = [subject, '']
  data = [scoresCompare.scale, 36 - scoresCompare.scale]
  backgroundColor = [color, '#4d4d4d']
  hoverBackgroundColor = backgroundColor
}
let scoresCompares = 0
if (scoresCompare) {
  scoresCompares = scoresCompare.scale
  if (isStudent) {
    scoresCompares = Math.round(scoresCompares)
  } else {
    scoresCompares = Math.round(scoresCompares * 10) / 10
  }
}



  return (
    // <Card>
    //   <CardBody>
    <Row className='subtest-report-top-card'>
      <Col xs='12' md='6' lg='4' xl='3'>
        <AssessDashCircle
          labels={labels}
          data={data}
          backgroundColor={backgroundColor}
          hoverBackgroundColor={hoverBackgroundColor}
          score={score}
          subject={subject}
          top={false}
          compareScore = {scoresCompares}
          isCompare = {isCompare}
          test1 = {test1}
          test2 = {test2}
          isSwap = {isSwap}
        />
      </Col>
      <Col xs='12' md='6' lg='8' xl='9'>
        <h2 className='subtest-name'>{title}</h2>
        <Link to={linkto} style={{'textDecoration': 'none'}}>
        <ul className='horizontal-bars type-2'>
          <AssessSkillBar
            nodeName='Raw Score'
            raw={scores ? scores.raw : 0}
            possible={scores ? scores.possible : 0}
            color={themeColor}
            percent={scores ? Math.round(scores.raw / scores.possible * 100) : 0}
            className='subtest-score'
            percentCompare={scoresCompare ? Math.round(scoresCompare.raw / scoresCompare.possible * 100) : 0}
            
          />
        </ul>
        </Link>
      </Col>
    </Row>
    //   </CardBody>
    // </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessReport/SubtestReportTopCard.js